var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134,105.1c-1.4-1.4-3.3-2.3-5.5-2.3h-1.4v-5.2h-12.8v2.7h10.1v2.5h-11.4c-2.1,0-4.1,0.9-5.5,2.3c-1.4,1.4-2.3,3.3-2.3,5.5 c0,2.1,0.9,4.1,2.3,5.5c1.4,1.4,3.3,2.3,5.5,2.3h15.5c2.1,0,4.1-0.9,5.5-2.3c1.4-1.4,2.3-3.3,2.3-5.5 C136.3,108.4,135.4,106.5,134,105.1z M132.1,114.1c-0.9,0.9-2.2,1.5-3.5,1.5h-15.5c-1.3,0-2.6-0.5-3.5-1.5 c-0.9-0.9-1.5-2.2-1.5-3.5c0-1.3,0.5-2.6,1.5-3.5c0.9-0.9,2.2-1.5,3.5-1.5h15.5c1.3,0,2.6,0.5,3.5,1.5c0.9,0.9,1.5,2.2,1.5,3.5 C133.6,111.9,133,113.2,132.1,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,87.6c1-1,1.5-2.3,1.5-3.6c0-1.3-0.5-2.6-1.5-3.6L82.1,51.2c-1.6-1.6-3.9-2.6-6.4-2.6c-2.5,0-4.7,1-6.4,2.6 L39.5,81.1h25.5l16.3-16.3l22.7,22.7c1,1,2.3,1.5,3.6,1.5C108.8,89.1,110.2,88.6,111.2,87.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.3,
    cy: 41.1,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,87.7c-0.9-0.9-2.2-1.5-3.6-1.5H34.4L12.6,108H0v10.3l14.7,0c1.4,0,2.7-0.6,3.6-1.5l20.3-20.3h28.5l-13,13 c-1,1-1.5,2.3-1.5,3.6c0,1.3,0.5,2.6,1.5,3.6c1,1,2.3,1.5,3.6,1.5c1.3,0,2.6-0.5,3.6-1.5L83.2,95c0.9-0.9,1.5-2.2,1.5-3.6 C84.7,89.9,84.1,88.6,83.2,87.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurling);
export default __webpack_public_path__ + "static/media/curling.d3fd2777ee0db28b8796583ba0e5a13b.svg";
export { ForwardRef as ReactComponent };